export const BASIC_MISSION_LOG_LIST_REQUEST = 'BASIC_MISSION_LOG_LIST_REQUEST';
